const urlBackend = 'http://18.216.16.2:3333';
export default urlBackend;